import React, {useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import '~/assets/scss/main.scss';
import rootStore, {AppDispatch} from '~/redux/root-store';
import {initSentry} from '~/services/sentry';
import {privateRoutes, publicRoutes} from '~/routes';
import config from '~/config/app-config';
import appConfig from '~/config/app-config';
import {getCurrentUserFromStorage} from '~/services/auth';
import {RootState} from '~/redux/root-reducer';
import {Provider, useDispatch, useSelector} from 'react-redux';
import {AppRouter, UiPageLoading} from '~/components/elements';
import {ignoreLogs} from '~/services/ignore-logs';
import {onLoginSuccessMisc} from '~/redux/auth/thunk';
import {ChakraProvider, ColorModeScript} from '@chakra-ui/react';
import {uiTheme} from '~/theme/chakra-theme';
import {useHistory} from 'react-router-dom';
import {GoogleOAuthProvider} from '@react-oauth/google';
import {initGA} from '~/services/google-analytics';
import {GTMProvider} from '@elgorditosalsero/react-gtm-hook';

import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

ignoreLogs();

initSentry();
initGA();
const Root = () => {
  const gtmParams = {id: appConfig.gtmId || ''};
  return (
    <Provider store={rootStore}>
      <GoogleOAuthProvider clientId={appConfig.googleClientId}>
        <GTMProvider state={gtmParams}>
          <ChakraProvider theme={uiTheme}>
            <App />
          </ChakraProvider>
        </GTMProvider>
      </GoogleOAuthProvider>
    </Provider>
  );
};

const App = () => {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  const token = useSelector((state: RootState) => state.auth.token)!;

  const [isInitializing, setIsInitializing] = useState(true);

  useEffect(() => {
    const init = async () => {
      const {accessToken: savedToken} = getCurrentUserFromStorage();
      setIsInitializing(false);
    };
    init();
  }, [dispatch]);

  if (isInitializing) {
    return <UiPageLoading />;
  }

  return <AppRouter basename={config.routeBaseName} publicRoutes={publicRoutes} defaultRedirect="/" />;
};

ReactDOM.render(
  <React.StrictMode>
    <ColorModeScript initialColorMode={uiTheme.config.initialColorMode} />
    <Root />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
